<template>
    <v-app-bar
            app
            color="primary"
            dark
    >
        <v-img v-if="$store.getters.GET_ROUTE"
               contain max-width="150"
               @click="$routerService.goTo('main')"
               class="nitg__logo"
               src="@/assets/logo.png"
               alt="NITG Helpdesk Navbar Logo"></v-img>
        <v-spacer/>
        <v-btn @click="toggleDrawer" icon>
            <v-icon :size="24" color="#fff">mdi-menu</v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
    export default {
        name: "AppBarComponent",
        methods: {
            toggleDrawer() {
                this.$store.dispatch('setDrawer', true);
            }
        }
    }
</script>

<style scoped>

</style>
